<template>
  <div
    id="users-screen"
    :style="
      isLoading
        ? 'display: flex; justify-content: center; align-items: center;'
        : ''
    "
  >
    <template v-if="!isLoading">
      <div class="action-wrapper">
        <rounded-button
          width="fit-content"
          height="35px"
          fontSize="14px"
          @click="createNewUser"
          >{{ $t("usersScreen.pageAction.button") }}
        </rounded-button>
      </div>
      <div class="users-wrapper">
        <div
          class="user-item-wrapper"
          v-for="(item, index) in this.filteredUsers"
          :key="index"
        >
          <user-item @userDeleted="getUsers" class="user-item" :user="item" />
        </div>
      </div>
    </template>
    <template v-else>
      <loader-ring />
    </template>
  </div>
</template>

<script>
import UserItem from "@/components/modules/Users/UserItem";
import { mapActions } from "vuex";
import UserModal from "@/components/modules/Users/UserModal";
export default {
  name: "UserScreen",
  components: {
    UserItem
  },
  data() {
    return {
      users: [],
      filteredUsers: [],
      isLoading: false
    };
  },
  created() {
    this.getUsers();
    this.$eventBus.onInitPageData(this, () => {
      this.getUsers();
    });
  },
  beforeDestroy() {
    this.$eventBus.offInitPageData();
  },
  methods: {
    ...mapActions({
      readUser: "user/readUser",
      readUsers: "user/readUsers"
    }),
    filterByWord(payload) {
      this.filteredUsers = this.users.filter(user => {
        return user.fullName.toLowerCase().includes(payload.toLowerCase());
      });
    },
    filteredUserChanged(payload) {
      this.filteredUsers = this.users.filter(user => {
        if (payload.key !== null) {
          return user.id === payload.key;
        } else {
          return user.fullName
            .toLowerCase()
            .includes(payload.value.toLowerCase());
        }
      });
    },
    createNewUser() {
      this.$eventBus.showModal({
        bind: {
          is: UserModal,
          width: "500px",
          height: "405px"
        },
        title: this.$t("usersScreen.userModal.create.title")
      });
    },
    getUsers() {
      this.isLoading = true;
      this.readUsers().then(res => {
        if (res.status === "OK") {
          this.users = res.data;
          this.filteredUsers = res.data;
          this.isLoading = false;
        }
      });
    }
  }
};
</script>
<style lang="scss" scoped>
#users-screen {
  min-height: 100%;
  .action-wrapper {
    padding-top: 10px;
  }
  .filter-wrapper {
    width: 100%;
    margin-top: 40px;
    .autocomplete-wrapper {
      width: 450px;
      max-width: 100%;
      margin: auto;
    }
  }
  .users-wrapper {
    margin-top: 40px;
    display: grid;
    grid-template-columns: repeat(3, 1fr);
    .user-item-wrapper {
      margin-bottom: 10px;
      padding-left: 5px;
      padding-right: 5px;
    }
  }
}
@media (max-width: 1160px) {
  .users-wrapper {
    grid-template-columns: repeat(1, 1fr) !important;
  }
}
@media (max-width: 1600px) and (min-width: 1161px) {
  .users-wrapper {
    grid-template-columns: repeat(2, 1fr) !important;
  }
}
@media (max-width: 1900px) and (min-width: 1601px) {
  .users-wrapper {
    grid-template-columns: repeat(3, 1fr) !important;
  }
}
@media (min-width: 1901px) {
  .users-wrapper {
    grid-template-columns: repeat(4, 1fr) !important;
  }
}
</style>
